// @flow
import React, { useContext } from 'react';

import appConfig from 'Config';
import { useRouter } from 'Client/router/useRouter';
import ReactAppContext from 'Context/ReactAppContext';
import { isSeller } from 'Utils/seller/sellerUtils';
import { isStrictlyProductionEnv, isStrictlyTestEnv } from 'Utils/context/contextUtils';
import { getConfigWithNoThirdPartySupport } from './thirdParty.utils';

export const ContentSquare = () => {
  const {
    location: { queryParams },
  } = useRouter<UrlParams, GlobalQueryParams>();
  const appContext = useContext(ReactAppContext);
  const config = getConfigWithNoThirdPartySupport({
    name: 'tracking',
    locale: appContext.locale,
    queryParams,
  });

  if (
    !isStrictlyProductionEnv(appConfig) &&
    !isStrictlyTestEnv(appConfig) &&
    !isSeller(appContext) &&
    config.enabled &&
    config.contentsquare.devId
  ) {
    return (
      <script
        defer
        src={`//t.contentsquare.net/uxa/${config.contentsquare.devId}.js`}
        type="text/javascript"
        charSet="utf-8"
      />
    );
  }

  return null;
};
